<style>
.tool {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.this__block {
  line-height: 33px;
}
</style>
<template>
  <div class="this__block demo__flex demo__flex-middle caption tool-panel">
    <span :id="tool.id" class="tool" v-for="tool in toolPanel" :key="tool.id">
      <component
        v-if="tool.type === 'single'"
        :is="tool.id + 'Tool'"
      ></component>
      <SomeTool v-if="tool.type === 'some'" :tool="tool.tool" />

      <ToolGroupBtn
        v-if="tool.type === 'group'"
        :icon="
          tool.group.data.active ? tool.group.data.active.icon : tool.group.icon
        "
        :hotkey-icon="
          tool.group.data.active
            ? tool.group.data.active.hotkey
              ? tool.group.data.active.hotkey.icon
              : null
            : tool.group.data.defaultTool.hotkey
            ? tool.group.data.defaultTool.hotkey.icon
            : null
        "
        :deselect="true"
        :active="!!tool.group.data.active"
        :active-tool="tool.group.data.active || tool.group.data.defaultTool"
        :title="
          tool.group.data.active
            ? $t(tool.group.data.active.id)
            : $t(tool.group.data.defaultTool.id)
        "
      >
        <a-popover
          :title="$t(tool.group.id)"
          overlayClassName="tool_group"
          trigger="click"
          :visible="tool.group.popover"
        >
          <template slot="content">
            <a-list
              item-layout="horizontal"
              :data-source="tool.group.data.tools"
            >
              <a-list-item
                slot="renderItem"
                slot-scope="subtool"
                :class="{ disabled: activeTools.indexOf(subtool.id) !== -1 }"
              >
                <SomeTool
                  :key="subtool.id"
                  :tool="subtool"
                  :text-mode="true"
                  :group_id="tool.group.id"
                  :deselect="false"
                />
              </a-list-item>
            </a-list>
          </template>
          <div
            class="tool-group-btn__item tool-group-btn__arrow"
            @click="
              tooglePopover({
                tool_id: tool.group.id,
                enable: !tool.group.popover,
              })
            "
          >
            <i class="fa fa-solid fa-chevron-down"></i>
          </div>
        </a-popover>
      </ToolGroupBtn>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import GridTool from "./components/GridTool";
import SyncTool from "./components/SyncTool";
import SomeTool from "./components/SomeTool";
// import ResetTool from "./components/ResetTool";
// import SaveTool from "./components/SaveTool";

import InvertTool from "./components/InvertTool";
import ClipTool from "./components/ClipTool";
import ToolGroupBtn from "./components/ToolGroupBtn/";
// import MagnifyTool from "./components/MagnifyTool";
// import StackScrollMouseWheelTool from "./components/StackScrollMouseWheelTool";
import WwwcTool from "./components/WwwcTool";
// import DragProbeTool from "./components/DragProbeTool";
// import PanTool from "./components/PanTool";
// import RotateTool from "./components/RotateTool";
// import ScaleOverlayTool from "./components/ScaleOverlayTool";
import MPRTool from "./components/MPRTool";
import ImportSegTool from "./components/ImportSegTool";
import ExportSegTool from "./components/ExportSegTool";

import DublicateAnnotationTool from "./components/DublicateAnnotationTool";

export default {
  components: {
    GridTool,
    SyncTool,
    SomeTool,
    // ResetTool,
    // SaveTool,
    InvertTool,
    ClipTool,
    ToolGroupBtn,
    // MagnifyTool,
    // StackScrollMouseWheelTool,
    WwwcTool,
    // DragProbeTool,
    // PanTool,
    // RotateTool,
    // ScaleOverlayTool,
    MPRTool,
    DublicateAnnotationTool,
    ImportSegTool,
    ExportSegTool,
  },
  computed: {
    ...mapGetters(["tools", "toolsGroups", "activeTools", "isMPR", "isMobile"]),
    toolPanel() {
      return [
        {
          id: "Grid",
          type: "single",
        },
        {
          id: "Sync",
          type: "single",
        },
        {
          id: "StackScroll",
          type: "some",
          tool: this.getToolFromToolsList("StackScroll"),
        },
        {
          id: "Wwwc",
          type: "single",
        },
        {
          id: "Move",
          type: "some",
          tool: this.getToolFromToolsList("Pan"),
        },
        {
          id: "ReferenceCursors",
          type: "some",
          hide: this.isMPR,
          tool: this.getToolFromToolsList("ReferenceCursors"),
        },
        {
          id: "Zoom",
          type: "group",
          group: this.toolsGroupsWithData[0],
        },
        {
          id: "Ruler",
          type: "group",
          group: this.toolsGroupsWithData[1],
        },
        // {
        //   id: "Brush",
        //   type: "group",
        //   group: this.toolsGroupsWithData[3],
        // },
        {
          id: "Invert",
          type: "single",
        },
        {
          id: "Clip",
          type: "single",
        },
        {
          id: "MPR",
          type: "single",
          hide: this.isMobile,
        },
        {
          id: "Crosshairs",
          type: "some",
          hide: !this.isMPR,
          tool: this.getToolFromToolsList("Crosshairs"),
        },
        // {
        //   id: "DublicateAnnotation",
        //   type: "single",
        // },
        {
          id: "Rotate",
          type: "group",
          group: this.toolsGroupsWithData[2],
        },
        // {
        //   id: "ImportSeg",
        //   type: "single",
        //   hide: false,
        // },
        // {
        //   id: "ExportSeg",
        //   type: "single",
        //   hide: false,
        // },
      ].filter((tool) => !tool.hide);
    },
    toolsGroupsWithData() {
      return this.toolsGroups
        .map((group) => {
          group.data = this.getGroup(group.id);
          group.isGeneral = group.id === "general";
          return group;
        })
        .filter((group) => {
          return group.id !== "general";
        });
    },
  },
  watch: {
    $route() {
      this.$store.dispatch("tooglePopover", {});
    },
  },
  created() {
    this.$accessModule("panel", this);
  },
  methods: {
    getToolFromToolsList(toolId) {
      return this.$_.findWhere(this.tools, { id: toolId });
    },
    tooglePopover(data) {
      this.$store.dispatch("tooglePopover", data);
    },
    getGroup(id) {
      return {
        tools: this.tools.filter((tool) => {
          return tool.group === id && tool.show !== false;
        }),
        defaultTool: this.tools.filter((tool) => {
          return tool.group === id && tool.default === true;
        })[0],
        active: this.tools.filter((tool) => {
          return tool.group === id && this.activeTools.indexOf(tool.id) !== -1;
        })[0],
      };
    },
  },
};
</script>
